import { action, observable } from "mobx"

class HistoryStore {
  
  @observable history = [] // contains custom history
  @observable fullHistory = [] // contains all history
  @observable search = ""
  @observable artnr = 0
  
  @action
  reset() {
    this.history = []
  }
  
  getPreviousLocation(){
    return this.fullHistory[this.fullHistory.length-2]
  }
  
  @action
  setSearch( query, artnr = 0 ) {
    this.search = query
    this.artnr = artnr
  }
  
  @action
  push( { key, content, link } ) {
    this.history.push( { key, content, link } )
  }
  
  @action
  set( { key, content, link } ) {
    this.history = [{ key, content, link }]
  }
  
  fromPath( path ) {
    if ( path.length > 0 ) {
      this.set( {
        content: path[ path.length - 1 ].title,
        link   : path[ path.length - 1 ].link
      } )
    }
  }
}


const historyStore = new HistoryStore()
window.historyStore = historyStore

export default historyStore



// WEBPACK FOOTER //
// ./src/stores/historyStore.js